// extracted by mini-css-extract-plugin
module.exports = {"container":"DistributorMainContainer_container__1XRtx"};